exports = module.exports = require("../../../css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../css-loader/index.js!./labvariables.css"), "");
exports.i(require("-!../../../css-loader/index.js!./widgets-base.css"), "");

// module
exports.push([module.id, "/* Copyright (c) Jupyter Development Team.\n * Distributed under the terms of the Modified BSD License.\n */\n\n /* We import all of these together in a single css file because the Webpack\nloader sees only one file at a time. This allows postcss to see the variable\ndefinitions when they are used. */\n", ""]);

// exports
